// extracted by mini-css-extract-plugin
module.exports = {"Legal":"SignupFields_Legal__LtBLu","EmailOptIn":"SignupFields_EmailOptIn__Kg89K"};